var RequestersComponentModule = /** @class */ (function () {
    function RequestersComponentModule() {
    }
    return RequestersComponentModule;
}());
export { RequestersComponentModule };
